import { render, staticRenderFns } from "./TimeoutWarning.vue?vue&type=template&id=5827e2fe"
import script from "./TimeoutWarning.vue?vue&type=script&lang=js"
export * from "./TimeoutWarning.vue?vue&type=script&lang=js"
import style0 from "./TimeoutWarning.vue?vue&type=style&index=0&id=5827e2fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports